module.exports = __webpack_public_path__ + "img/diagnosticrecord.70343a4e.svg";